import Breadcrumb from "../../../components/Breadcrumbs/Breadcrumb.tsx";
import { useAuth } from "../../../provider/AuthProvider.tsx";
import { DocumentsPanel } from "./components/DocumentsPanel.tsx";
import { Feedback, NoticeBox } from "./components/Feedback.tsx";
import { InstallmentsPanel } from "./components/InstallmentsPanel.tsx";
import { IssuePanel } from "./components/IssuePanel.tsx";
import { OffersPanel } from "./components/OffersPanel.tsx";
import { PartyCards } from "./components/PartyCards.tsx";
import { PolicyPanel } from "./components/PolicyPanel.tsx";
import { QuoteEditor } from "./components/QuoteEditor.tsx";
import {
  type CalculatorHandoff,
  useCalculatorHandoff,
  useCalculatorQuote,
} from "./calculatorHandoff.tsx";
import { useLifecycle } from "./useLifecycle.ts";

function LifecyclePage({
  jwt,
  account,
  headOff,
  handoff,
}: {
  jwt: string;
  account: string;
  headOff: string;
  handoff: CalculatorHandoff | null;
}) {
  const controller = useLifecycle(
    jwt,
    account,
    headOff,
    handoff
      ? { plate: handoff.plate, certNumber: handoff.certNumber, pin: handoff.pin }
      : undefined
  );
  useCalculatorQuote(controller, handoff);
  return (
    <>
      <Breadcrumb pageName="Нова полица" />
      <div className="mx-auto w-full max-w-[1600px] space-y-4 p-4 lg:px-6">
        <QuoteEditor controller={controller} />
        <Feedback controller={controller} />
        {controller.stale && (
          <NoticeBox
            notice={{
              kind: "warning",
              text: "Данните са променени след изчисляването. Натиснете „Преизчисли“, преди да издадете.",
            }}
          />
        )}
        {controller.leasing?.detected && (
          <NoticeBox
            notice={{
              kind: controller.lesseeMissing ? "warning" : "success",
              text: `Лизингов автомобил. Собственик е ${
                controller.leasing.ownerName || "лизингова компания"
              }.${
                controller.lesseeMissing
                  ? " Въведете лизингополучателя в „Застраховащ“ и преизчислете офертите."
                  : " Лизингополучателят ще бъде подаден отделно от собственика."
              }`,
            }}
          />
        )}
        <PartyCards controller={controller} />
        <OffersPanel controller={controller} />
        <IssuePanel controller={controller} />
        <PolicyPanel controller={controller} />
        <DocumentsPanel controller={controller} />
        <InstallmentsPanel controller={controller} />
      </div>
    </>
  );
}
export default function Lifecycle() {
  const { jwt, userID, headOff } = useAuth();
  const handoff = useCalculatorHandoff();
  if (!jwt || !userID || !headOff) return null;
  const account = JSON.stringify([headOff, userID]);
  return (
    <LifecyclePage
      key={account}
      jwt={jwt}
      account={account}
      headOff={headOff}
      handoff={handoff}
    />
  );
}
